import { postToApi } from '../../common/utils/apiHelper';
import { GetAssetRevenueResponse } from './models/GetAssetRevenueResponse';

export function getAssetRevenue(apiBaseUrl: string, propertyAssociationId: string, year: number, month: number | undefined, assetIdFilter: string[] | undefined, onSuccess: (data: GetAssetRevenueResponse) => void, onFail: () => void): void {
    const data = { year, month, assetIdFilter };
    postToApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/statistics/assets/revenue`, data, onSuccess, onFail);
}